import { BOOLEAN_CHOICES } from 'constants/booleanChoices';
import { SECURITY_ISSUES_SELECT_ITEMS } from 'constants/securityIssues';

import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterBar, FilterBarActions, FilterBarRow } from 'shared/mui/Filter/FilterBar';
import { FilterApplyButton, FilterResetButton } from 'shared/mui/Filter/FilterButtons';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import { AutocompleteInput, SelectInput, TextInput } from 'shared/react-admin/Inputs';

type ProvidersFilterValues = {
  name: string;
  active: boolean | null;
  securityIssues: string | null;
};

const DEFAULT_VALUES: ProvidersFilterValues = { active: null, name: '', securityIssues: null };

export const ProvidersFilter: React.FC = () => {
  const { filterValues } = useListContext();
  const { form, onReset, onSubmit, appliedFilters } = useFilters<ProvidersFilterValues>({
    defaultValues: { ...DEFAULT_VALUES, ...filterValues },
    resetValues: DEFAULT_VALUES,
  });

  useSyncFilter<ProvidersFilterValues>({ appliedFilters });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <FilterBar>
          <FilterBarRow sx={{ gridTemplateColumns: '1fr 1fr 1fr 272px' }}>
            <TextInput
              helperText={false}
              label="Название"
              name="name"
              source="name"
              variant="outlined"
            />
            <AutocompleteInput
              choices={BOOLEAN_CHOICES}
              helperText={false}
              label="Активен"
              name="active"
              source="active"
              variant="outlined"
            />
            <SelectInput
              choices={SECURITY_ISSUES_SELECT_ITEMS}
              defaultValue={null}
              helperText={false}
              id="securityIssues"
              label="Уведомление безопасности"
              name="securityIssues"
              source="securityIssues"
              variant="outlined"
            />
            <FilterBarActions>
              <FilterResetButton onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterBarActions>
          </FilterBarRow>
        </FilterBar>
      </form>
    </FormProvider>
  );
};
